import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface HttpErrorPolicyResult {
  message: string;
  shouldShowToast: boolean;
  shouldRedirect: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class RequestErrorPolicyService {
  classifyHttpError(error: HttpErrorResponse): HttpErrorPolicyResult {
    const message = this.extractHttpErrorMessage(error);
    const isBadRequestOrConflict = error.status === 400 || error.status === 409;

    if (isBadRequestOrConflict && !!message) {
      return {
        message,
        shouldShowToast: true,
        shouldRedirect: false,
      };
    }

    return {
      message,
      shouldShowToast: !!message,
      shouldRedirect: this.shouldRedirect(error),
    };
  }

  resolveNonHttpMessage(error: unknown, fallbackMessage: string): string {
    if (error instanceof HttpErrorResponse) {
      return '';
    }

    if (error instanceof Error && error.message?.trim()) {
      return error.message;
    }

    return fallbackMessage;
  }

  private extractHttpErrorMessage(error: HttpErrorResponse): string {
    const backendError = error.error;

    if (!backendError || typeof backendError !== 'object' || !('message' in backendError)) {
      return '';
    }

    return String(backendError.message ?? '').trim();
  }

  private shouldRedirect(error: HttpErrorResponse): boolean {
    const neverRedirect = [400, 409];
    return !neverRedirect.includes(error.status);
  }
}
